var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTune = function SvgTune(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 11.333v1.334h4v-1.334zm0-8v1.334h6.667V3.333zM8.667 14v-1.333H14v-1.334H8.667V10H7.333v4zm-4-8v1.333H2v1.334h2.667V10H6V6zM14 8.667V7.333H7.333v1.334zM10 6h1.333V4.667H14V3.333h-2.667V2H10z"
  })));
};
export default SvgTune;